import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { ServiceContextmenuComponent } from '@app/core/components/contextmenus';
import { CreateEditServiceOutputComponent, EditServiceInventoryComponent, EditInvoiceComponent } from '@app/core/windows'; 


@Component({
  selector: 'services-crud',
  templateUrl: './services-crud.component.html',
  providers: [ DatasourceService ]
})
export class ServicesCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditServiceOutputComponent, {static: false}) window !: CreateEditServiceOutputComponent;

  //Window
  @ViewChild(EditServiceInventoryComponent, {static: false}) window_lib !: EditServiceInventoryComponent;

  //Window - Invoice
  @ViewChild(EditInvoiceComponent, {static: false}) window_inv !: EditInvoiceComponent;

  //Menu
  @ViewChild(ServiceContextmenuComponent, {static: false}) menu_ser !: ServiceContextmenuComponent;

  protected menu: string = 'Movimientos';

  protected menuIcon: string = 'arrows-swap';
  
  protected label: string = 'Salida de Servicio';

  protected name: string = 'Servicios';

  protected table: string = 'services_inventories';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'output_date', dir: 'desc'}
    ];

    return s;

  }

  public onCustomExcelExport(e: any, allData: Array<any>): void {

    console.log('onCustomExcelExport');

    const rows = e.workbook.sheets[0].rows;

    let index = 0;
    rows.forEach((row) => {
      if (row.type === 'data') {+
        index++;
        row.cells.forEach((cell, i) => {
          if(typeof cell._column != 'undefined'){
            switch(cell._column){
              case 'Estatus': {
                cell.background = '#' + allData[index-1].service_status_color;
                cell.color = '#ffffff';
              }; break;
              case 'Costo': {
                cell.format = "$#,##0.00";
              }; break;
            }
          }
        });
      }
    });

  }

  public onCellClick(e: any): void {
      
    console.log(e);
    if (e.type === 'contextmenu') {
      const originalEvent = e.originalEvent;
      originalEvent.preventDefault();
      // this.menu_proy.label = 'Folio consecutivo: ' + e.dataItem.folio_consecutivo;
      this.menu_ser.contextItem = e.dataItem;
      this.menu_ser.menu.show({ left: originalEvent.pageX, top: originalEvent.pageY });
    }

  }

  // public dblClickEvent(e : any) : void {

  //   // console.log('dblClickEvent', e);
  //   if (e.path[1].nodeName === 'TR') {
  //     let index = e.path[1].rowIndex;
  //     let data : DataResult = this.grid.data as DataResult;
  //     this.permissions.edit(data.data[index]);
  //   }

  // }

  public selectMenu({ menu, contextItem }): void {
    
    console.log("selectMenu", menu, contextItem);

    if (menu.url === 'editar') {

      this.window.label = this.label;
      this.window.table = this.table;
      this.window.edit(contextItem);

    } else if (menu.url === 'eliminar') {
        
      this.removeHandler({dataItem: contextItem});

    } else if (menu.url === 'recepcion') {
        
      this.window_lib.label = this.label;
      this.window_lib.table = this.table;
      this.window_lib.edit(contextItem);

    } else if (menu.url === 'eliminar_recepcion') {
        
      this.window_lib.delete(contextItem);

    } else if (menu.url === 'factura') {
        
      this.window_inv.edit(contextItem);

    }

  }

  protected windowSaveInvoiceHandler({mode, dataItem}) {

    let msg = this.window_inv.getObjectString(dataItem)
    this.alertService.showUpdateSuccess(msg);
    this.service.pagination(this.table, this.state);

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}